export const MainWrapper =
  'group text-14 font-Roboto hover:border-accentYellow mb-2 flex w-full cursor-pointer flex-col border-b border-machine2-75 bg-white pb-2 last-of-type:border-0 last-of-type:mb-0'

export const OrderDateContent = 'w-full md:w-1/2 group-hover:underline'

export const OrderNoContent =
  'w-full md:w-1/2 pt-1 md:pt-0 group-hover:underline'

export const OrderContentWrapper = 'flex w-full flex-row items-center text-14'

export const OrderLeftColWrapper =
  'flex min-w-[90px] shrink-0 flex-col md:flex-row justify-between md:w-[350px]'

export const OrderRightColWrapper = 'flex grow'

export const OrderProductsImageWrapper =
  'relative mr-1 md:mr-[10px] h-fit max-h-[40px] min-h-[30px] w-auto min-w-[30px] max-w-[40px] last-of-type:mr-0'

export const OrderProductImage = 'z-0 w-full'

export const OrderProductImageOverlayInfo =
  'z-1 font-Roboto text-16 sm:text-16 bg-whiteTransparent absolute left-0 top-0 flex h-full w-full items-center justify-center text-black'
